module.exports = __webpack_public_path__ + "img/SMALL.62fe299a.png";